const services = [
  {
    title: 'İnşaat Sonrası Temizlik',
    desc: 'Yeni inşaat, tadilat ve inşaat sonrası alanların detaylı profesyonel temizliği.',
    cta: 'İnşaat Sonrası Teklif Al',
    img: 'https://readdy.ai/api/search-image?query=Modern%20construction%20site%20interior%20after%20renovation%20with%20professional%20cleaning%20equipment%20and%20clean%20marble%20floors%2C%20large%20bright%20windows%2C%20warm%20ambient%20light%2C%20high-end%20residential%20construction%20finish%2C%20editorial%20photography&width=600&height=400&seq=service-insaat&orientation=landscape',
    message: 'Merhaba%2C%20in%C5%9Faat%20sonras%C4%B1%20temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.',
  },
  {
    title: 'Villa Temizliği',
    desc: 'Büyük ölçekli lüks konutların detaylı, planlı ve profesyonel temizliği.',
    cta: 'Villam İçin Teklif Al',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20villa%20interior%20with%20sweeping%20ocean%20view%20through%20floor%20to%20ceiling%20windows%2C%20marble%20floors%2C%20high%20ceilings%2C%20elegant%20furniture%2C%20natural%20warm%20light%2C%20premium%20residential%20architecture%2C%20editorial%20photography&width=600&height=400&seq=service-villa&orientation=landscape',
    message: 'Merhaba%2C%20villam%20i%C3%A7in%20profesyonel%20temizlik%20teklifi%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6nderebilirim.',
  },
  {
    title: 'Residence Temizliği',
    desc: 'Modern residence ve lüks daire temizliği hizmetleri.',
    cta: 'Residence İçin Teklif Al',
    img: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20apartment%20living%20room%20with%20panoramic%20city%20view%2C%20minimalist%20design%2C%20neutral%20tones%2C%20marble%20and%20wood%20materials%2C%20warm%20ambient%20lighting%2C%20editorial%20interior%20photography%2C%20high-end%20residence&width=600&height=400&seq=service-residence&orientation=landscape',
    message: 'Merhaba%2C%20residence%20dairem%20i%C3%A7in%20profesyonel%20temizlik%20teklifi%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6nderebilirim.',
  },
  {
    title: 'Plaza & Ofis Temizliği',
    desc: 'Kurumsal ortamlar ve iş yerleri için profesyonel temizlik çözümleri.',
    cta: 'İş Yerim İçin Teklif Al',
    img: 'https://readdy.ai/api/search-image?query=Modern%20premium%20office%20lobby%20with%20reception%20desk%2C%20polished%20floors%2C%20floor%20to%20ceiling%20glass%20windows%2C%20contemporary%20design%2C%20warm%20neutral%20tones%2C%20professional%20corporate%20environment%2C%20editorial%20photography&width=600&height=400&seq=service-ofis&orientation=landscape',
    message: 'Merhaba%2C%20ofis%20ve%20i%C5%9F%20yerim%20i%C3%A7in%20profesyonel%20temizlik%20teklifi%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6nderebilirim.',
  },
  {
    title: 'Yazlık Ev Temizliği',
    desc: 'Mevsimsel konutlar ve büyük tatil evlerinin profesyonel temizliği.',
    cta: 'Yazlığım İçin Teklif Al',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20coastal%20summer%20house%20interior%20with%20sea%20view%20balcony%2C%20open%20plan%20living%20space%2C%20natural%20light%2C%20warm%20wood%20and%20white%20tones%2C%20relaxed%20elegant%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=service-yazlik&orientation=landscape',
    message: 'Merhaba%2C%20yazl%C4%B1k%20evim%20i%C3%A7in%20profesyonel%20temizlik%20teklifi%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6nderebilirim.',
  },
  {
    title: 'Koltuk Yıkama',
    desc: 'Profesyonel döşeme ve koltuk temizliği hizmetleri.',
    cta: 'Koltuk Yıkama Bilgisi Al',
    img: 'https://readdy.ai/api/search-image?query=Professional%20upholstery%20cleaning%20process%20in%20luxury%20living%20room%2C%20modern%20sofa%20being%20cleaned%20with%20professional%20equipment%2C%20warm%20natural%20light%2C%20clean%20and%20organized%20workspace%2C%20editorial%20photography%2C%20premium%20service%20aesthetic&width=600&height=400&seq=service-koltuk&orientation=landscape',
    message: 'Merhaba%2C%20koltuk%20y%C4%B1kama%20hizmeti%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.%20Alan%C4%B1n%20videosunu%20g%C3%B6nderebilirim.',
  },
];

export default function Services() {
  return (
    <section id="hizmetlerimiz" className="bg-warm-white py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-navy mb-4">
            PROFESYONEL TEMİZLİK ÇÖZÜMLERİ
          </h2>
          <p className="text-navy/60 text-base md:text-lg max-w-2xl mx-auto">
            Farklı yaşam ve çalışma alanları için ihtiyaca özel profesyonel temizlik hizmetleri.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-white border border-warm-sand rounded-lg overflow-hidden hover:border-gold/50 transition-all duration-300"
            >
              <div className="relative h-48 sm:h-56 overflow-hidden">
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent"></div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-display text-xl md:text-2xl font-bold text-navy mb-2">
                  {service.title}
                </h3>
                <p className="text-navy/60 text-sm md:text-base leading-relaxed mb-5">
                  {service.desc}
                </p>
                <a
                  href={`https://wa.me/905077089198?text=${service.message}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gold font-semibold text-sm hover:text-gold-dark transition-colors"
                >
                  {service.cta}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}